import { createGlobalStyle } from 'styled-components';

/**
 * Baseline global resets + font/colour defaults.
 *
 * The existing `src/styles.css` keeps the legacy variables that components
 * still consume directly during the styled-components migration; once every
 * component has been migrated, those CSS vars can be removed and this
 * GlobalStyle becomes the only source of baseline styling.
 */
export const GlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    height: 100%;
  }

  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    color: ${({ theme }) => theme.colors.textPrimary};
    background: ${({ theme }) => theme.colors.background};
    font-size: ${({ theme }) => theme.fontSizes.md};
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
